import axios from 'axios';
import React, { useState,useEffect } from 'react'
import { useParams } from 'react-router-dom';
import { URL } from '../config';
import SubTitle from '../Components/SubTitle';
import Loading from './Loading';

const Page = () => {
    const { term,id } = useParams();
    
    const [load,setLoad]=useState(false);
    const [page,setPage]=useState({});
    const titles = [{ name: page.name, link: '' }]
    useEffect(()=>{
        if(id){
            console.log('paasassad0',term)
            setLoad(true);
            axios.get(`${URL}/api/page/${id}`)
            .then(function (response) {
              if(response.data.success){
                console.log(response.data.data);
                setPage(response.data.data)
              }
              setLoad(false);
                })
            .catch(function (error) {
              console.log('error');
              setLoad(false);
            });
        }
       
      },[id])
      if(load)
        return <Loading/>
  return (
    <div className='page-back'>
         <div className='container-fluid mt-lg-5 pt-5 mb-2'>
         <SubTitle titles={titles} />
          <div className='page-white container'>
           
           {<div dangerouslySetInnerHTML={{ __html: page.description }} />}

          </div>
         </div>
      
    </div>
  )
}

export default Page